import { render, staticRenderFns } from "./StatTable.vue?vue&type=template&id=069b9d2e"
import script from "./StatTable.vue?vue&type=script&lang=js"
export * from "./StatTable.vue?vue&type=script&lang=js"
import style0 from "./StatTable.vue?vue&type=style&index=0&id=069b9d2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports